function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1d1d",
  d: "M24400.605 19141a1.636 1.636 0 0 1-1.6-1.666v-16.67a1.636 1.636 0 0 1 1.6-1.664h14.59l-3.211 3.332h-8.967a.819.819 0 0 0-.8.832v11.67a.82.82 0 0 0 .8.834h11.242a.817.817 0 0 0 .8-.834v-5.084l3.215-3.34v10.924a1.641 1.641 0 0 1-1.609 1.666zm7.367-5.428l-.57-.588-3.41-3.535a.857.857 0 0 1 .006-1.18l1.7-1.77a.788.788 0 0 1 1.139 0l1.7 1.77 7.387-7.664a.782.782 0 0 1 1.135.006l1.705 1.768a.841.841 0 0 1 0 1.168l-9.656 10.025a.779.779 0 0 1-1.137 0z",
  transform: "translate(-24394 -19116)"
});

function SvgIconChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecklist);
export default __webpack_public_path__ + "static/media/icon_checklist.e673a07f.svg";
export { ForwardRef as ReactComponent };